import type { SVGProps } from 'react';
const SvgEditDetalized = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#edit-detalized_svg__a)">
      <path
        fill="currentColor"
        fillOpacity={0.45}
        d="M3.46 12.284a1 1 0 0 0 .106-.009l3.004-.527a.18.18 0 0 0 .095-.05l7.57-7.57a.18.18 0 0 0 0-.251L11.265.907a.18.18 0 0 0-.126-.052.18.18 0 0 0-.127.052l-7.57 7.57a.2.2 0 0 0-.05.095l-.527 3.003a.6.6 0 0 0 .168.532.6.6 0 0 0 .425.177M4.662 9.17l6.477-6.475 1.308 1.309-6.476 6.475-1.588.28zm9.909 4.614H1.429a.57.57 0 0 0-.572.571v.643c0 .079.065.143.143.143h14a.143.143 0 0 0 .143-.143v-.643a.57.57 0 0 0-.571-.571"
      />
    </g>
    <defs>
      <clipPath id="edit-detalized_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEditDetalized;
